import React, { Component, createRef } from "react";
import Button from "../button/Button";
import Label from "../Label/Label";
import momentJalaali from "moment-jalaali";
import {Calendar} from "react-datepicker2";
import T from "../t/T";
import "./DatePicker.scss";
import { connect } from "react-redux";
import Storage from "../../../helpers/Storage";
import eventBus from "../../../core/utils/EventBus";
import snippets from "../../../helpers/snippets";
import { default as _ } from '../../../helpers/Translate';
import config from "../../../config";
import FilterByDays from "../../../core/constants/FilterByDays";
import MobileRangeDatePicker from "./MobileRangeDatePicker";
import {_alert} from "../../../actions/Alert";

class DatePickerr extends Component {
  constructor(props) {
    super(props);

    // Refs
    this.fromPickerRef = createRef();
    this.toPickerRef = createRef();

    this.state = {
      language: this.props.language,
      calendarType: this.props.calendar,
      filters: FilterByDays,
      customFilter: [
        {
          name: "datepickerFrom",
          showCalendar: false
        },
        {
          name: "datepickerTo",
          showCalendar: false
        }
      ],
      selectedFilterName: FilterByDays.find(item => item.value === config.daysBeforePanel)?.name,
      selectedCustomRangeFilter: {
        datepickerFrom: null,
        datepickerTo: null
      },
      selectedCustomRangeFilterName: [],
      selectedFilter: {
        datepickerFrom: config.daysBeforePanel,
        datepickerTo: null
      },
    };
  }

  componentDidMount() {
    eventBus.on("resetAllFilters", this.filterHandler);
    eventBus.on("DatePickerDatePropped", (e) => this.proppedDate(e, false));
    document.addEventListener("mousedown", this.#closeDatePicker);

    //these conditions are about button performances
    if (!snippets.isObjectEmpty(this.props?.defaultValue?.dateFrom) || this.props?.defaultValue?.filterName === "all") {
      this.proppedDate(this.props.defaultValue, false)
    }
  }

  componentWillUnmount() {
    eventBus.remove("resetAllFilters");
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.calendar !== this.props.calendar) {
      this.setState({ calendarType: this.props.calendar})
    }
    if (prevProps.language !== this.props.language) {
      this.setState({ language: this.props.language});
    }
}


  proppedDate = (date, sendToParent = true) =>{
    // ```propped data are with only two different kinds:
    //   1: first kind is like: date={dateTo: null, dateFrom:"year", "month", ... }
    //   2: "1389/01/02 -> 1402/08/08" this string converted to date={dateTo: 1402/08/08, dateFrom: 1389/01/02 }
    // ```
    if (date?.dateFrom <= 0 ){
      let obj = { target: {name: this.state.filters.find(item => item.value === date?.dateFrom)?.name} }
      this.filterHandler(obj, sendToParent)
      // sendToParent && this.changeDateOnParent(false, obj.target.name)
    }else if (date?.dateTo !== null && date?.dateFrom !== null && date?.filterName === "all") {
      let obj = { target: {name: date?.filterName} }
      this.filterHandler(obj, sendToParent)
    }else if (date?.dateTo !== null && date?.dateFrom !== null ) {
      //part of rangeDatePickerHandler() function
      this.setState({
        selectedCustomRangeFilter: {
          ...this.state.selectedCustomRangeFilter,
          "datepickerTo": momentJalaali(date?.dateTo).format("YYYY-MM-DD"),
          "datepickerFrom": momentJalaali(date?.dateFrom).format("YYYY-MM-DD")
        },
        selectedCustomRangeFilterName: [...this.state.selectedCustomRangeFilterName, "datepickerFrom", "datepickerTo"],
        selectedFilter: {
          datepickerFrom: null,
          datepickerTo: null
        },
        selectedFilterName: null
      }, ()=>{})
    }

  }

  changeDateOnParent = (isRange, e) =>{
    this.props?.onDateChanged(isRange, e)
  }


  #closeDatePicker = (event) => {
    if (this.fromPickerRef.current && !this.fromPickerRef.current.contains(event.target)) {
      this.state.customFilter.find(item => item.name === "datepickerFrom").showCalendar && this.toggleCalendar(null, "datepickerFrom");
    }
    if (this.toPickerRef.current && !this.toPickerRef.current.contains(event.target)) {
      this.state.customFilter.find(item => item.name === "datepickerTo").showCalendar && this.toggleCalendar(null, "datepickerTo");
    }
  }

  rangeDatePickerHandler = (value, target) => {
    let chosenDate = momentJalaali(value._d);

    this.setState({
      selectedCustomRangeFilter: {
        ...this.state.selectedCustomRangeFilter,
        [target]: chosenDate
      },
      selectedCustomRangeFilterName: [...this.state.selectedCustomRangeFilterName, target],
      selectedFilter: {
        datepickerFrom: null,
        datepickerTo: null
      },
      selectedFilterName: null,
      customFilter: [...this.updateCustomFilters(target)]
    }, () => {
      eventBus.dispatchEvent("filterByDate", {[target]: momentJalaali(value._d).format("YYYY-MM-DD")});
      // this.changeDateOnParent(true, this.state.selectedCustomRangeFilter)
    });
  }

  updateCustomFilters = (keyToFind = "") => {
    let otherValues = this.state.customFilter.filter(item => item.name !== keyToFind);
    let targetRecord = this.state.customFilter.find(item => item.name === keyToFind);
    let updatedOne = {
      ...targetRecord,
      showCalendar: !targetRecord.showCalendar
    };

    otherValues.push(updatedOne);

    return otherValues;
  }

  toggleCalendar = (event, directName = null) => {
    this.setState({
      customFilter: [...this.updateCustomFilters(directName ?? event.target.name)]
    });
  }

  getButtonsText = (fromDefaultName = "", toDefaultName = "") => {
    let dateFormat = "jYYYY/jMM/jDD";

    if (this.state.calendarType === "Gregorian") {
      dateFormat = "YYYY-MM-DD";
    }
    let fromDate = this.state.selectedCustomRangeFilter.datepickerFrom ? momentJalaali(this.state.selectedCustomRangeFilter.datepickerFrom).format(dateFormat) : <T token={fromDefaultName} />;

    let toDate = this.state.selectedCustomRangeFilter.datepickerTo ? momentJalaali(this.state.selectedCustomRangeFilter.datepickerTo).format(dateFormat) : <T token={toDefaultName} />;

    return {
      fromDate,
      toDate
    };
  }

  changeDateHandler = (from, to) => {
    if (from.valueOf() > to.valueOf()) {
      this.props.dispatch(_alert(true,"error", <T token={"end_larger_than_start_date"} />))
      return
    }
    let f = momentJalaali(from).format("YYYY-MM-DD")
    let t = momentJalaali(to).format("YYYY-MM-DD")
    this.setState({
      selectedFilter: {datepickerFrom: null, datepickerTo: null},
      selectedCustomRangeFilter: { datepickerFrom: f,datepickerTo: t},
      selectedFilterName: null,
    }, () => {this.changeDateOnParent(true, this.state.selectedCustomRangeFilter)});
  }

  rangeDatePicker = () => {
    let dateFromBtn = this.state.customFilter.find(item => item.name === "datepickerFrom");
    let dateToBtn = this.state.customFilter.find(item => item.name === "datepickerTo");

    let {fromDate, toDate} = this.getButtonsText(dateFromBtn.name, dateToBtn.name);

    return <div className={`range-datepicker margin-2px`}>
      <div ref={this.fromPickerRef}>
        <Button size="small" mode="gray-new"
        selected={this.state.selectedCustomRangeFilterName.includes(dateFromBtn.name)} 
        name={dateFromBtn.name} onClick={this.toggleCalendar}>{fromDate}</Button>
        {
          dateFromBtn.showCalendar &&
            <Calendar value={this.state.selectedCustomRangeFilter.datepickerFrom}
                      max={this.state.selectedCustomRangeFilter.datepickerTo}
                      isGregorian={this.state.calendarType === "Gregorian"}
                      onChange={(e) => this.rangeDatePickerHandler(e, dateFromBtn.name)} />
        }
      </div>
      <div ref={this.toPickerRef}>
        <Button size="small" mode="gray-new"
        selected={this.state.selectedCustomRangeFilterName.includes(dateToBtn.name)} 
        name={dateToBtn.name} onClick={this.toggleCalendar}>{toDate}</Button>
        {
          dateToBtn.showCalendar &&
            <Calendar value={this.state.selectedCustomRangeFilter.datepickerTo}
                      min={this.state.selectedCustomRangeFilter.datepickerFrom ?? momentJalaali().startOf('jMonth')}
                      isGregorian={this.state.calendarType === "Gregorian"}
                      onChange={(e) => this.rangeDatePickerHandler(e, dateToBtn.name)} />
        }
      </div>
    </div>
  }

  filterHandler = (event, sendToParent = true) => {
    let itemName = event?.target.name || FilterByDays.find(item => item.value === config.daysBeforePanel)?.name
    let finalFilterValue;
    let selectedFilter = this.state.filters.find(item => item.name === itemName);

    finalFilterValue = {
      datepickerFrom: selectedFilter.value,
      datepickerTo: null
    };

    this.setState({
      selectedFilter: {...finalFilterValue},
      selectedFilterName: itemName,
      selectedCustomRangeFilterName: [],
      selectedCustomRangeFilter: {
        datepickerFrom: null,
        datepickerTo: null
      }
    }, () => {
      // event && this.props.onDateChanged(this.state.selectedFilter);
      sendToParent && event && this.changeDateOnParent(false, this.state.selectedFilterName)
      sendToParent && event && eventBus.dispatchEvent("filterByDate", this.state.selectedFilter);
    });
  }

  renderFullDatePicker = (isDesktop = true) => {
    let calendar = this.state.calendarType
    return <>
      {
        this.state.filters.map((filterItem, index) =>
            <Button key={index} customClasses="margin-2px" size="small" mode="gray-new"
                    buttonText={filterItem.name}
                    selected={this.state.selectedFilterName === filterItem.name}
                    name={filterItem.name}
                    onClick={this.filterHandler}
                    tooltip={_.init4("from_date_to_date",
                        {date1: (snippets.time_days_before(filterItem.value, calendar)),
                          date2: (snippets.time_today(calendar)[0])}, this.state.language)}
            />)
      }
      { isDesktop ? this.rangeDatePicker() : <MobileRangeDatePicker defaultValue={this.state} changedRange={this.changeDateHandler}/> }
    </>
  }

  renderError = () => {
    return <div className="wrong-datepicker">{ <Label labelText={"wrong_type_error"} removeColon /> }</div>;
  }

  render() {
    const { type = "default", removeLabel = false } = this.props;
    let datePicker;

    switch (type.toLowerCase()) {
      case "full":
        datePicker = this.renderFullDatePicker();
        break;
      case "mobile":
        datePicker = this.renderFullDatePicker(false);
        break;
      default:
        datePicker = this.renderError();
        break;
    }

    return <div className="datepicker__container">
      {!removeLabel && <Label labelText={"interval"} color="gray" />}
      { datePicker ?? "" }
    </div>;
  }
}

const mapStateToProps = state => {
  const calendar = state.CalendarReducer.type;
  const language = state.LangReducer.language;
  return {calendar, language};
};

export default connect(mapStateToProps)(DatePickerr);
